import type { SorteoType } from '../types';

export interface BackendSorteoSeleccionable {
  id: string;
  tipo_id: string;
  nombre: string;
  fecha: string;
  hora_cierre: string;
  estado: string;
}

const TIPOS_OMITIDOS_EN_AUTO = new Set(['MONAZOS', 'PARLEY', 'FECHAS']);

export function segundosDesdeHora(hora: string): number {
  const [horas, minutos, segundos] = hora.split(':').map((parte) => Number(parte));
  if (!Number.isFinite(horas) || !Number.isFinite(minutos)) return Number.MAX_SAFE_INTEGER;
  return (horas * 3600) + (minutos * 60) + (Number.isFinite(segundos) ? segundos : 0);
}

function segundosActuales(ahora: Date): number {
  return (ahora.getHours() * 3600) + (ahora.getMinutes() * 60) + ahora.getSeconds();
}

export function obtenerSorteosAbiertosDisponibles(
  sorteos: BackendSorteoSeleccionable[],
  ahora: Date = new Date(),
): BackendSorteoSeleccionable[] {
  const segundoActual = segundosActuales(ahora);
  return sorteos.filter((sorteo) => (
    sorteo.estado === 'ABIERTO' && segundosDesdeHora(sorteo.hora_cierre) > segundoActual
  ));
}

function compararPorCierre(a: BackendSorteoSeleccionable, b: BackendSorteoSeleccionable): number {
  const cierreA = segundosDesdeHora(a.hora_cierre);
  const cierreB = segundosDesdeHora(b.hora_cierre);
  if (cierreA !== cierreB) return cierreA - cierreB;
  const nombre = a.nombre.localeCompare(b.nombre);
  if (nombre !== 0) return nombre;
  return a.id.localeCompare(b.id);
}

export function obtenerSorteoMasProximoACerrar(
  sorteos: BackendSorteoSeleccionable[],
  ahora: Date = new Date(),
): BackendSorteoSeleccionable | null {
  const disponibles = obtenerSorteosAbiertosDisponibles(sorteos, ahora);
  const principales = disponibles.filter((sorteo) => !TIPOS_OMITIDOS_EN_AUTO.has(sorteo.tipo_id));
  const candidatos = principales.length > 0 ? principales : disponibles;
  return [...candidatos].sort(compararPorCierre)[0] ?? null;
}

export function obtenerSorteoMasProximoPorTipo(
  sorteos: BackendSorteoSeleccionable[],
  tipoId: string,
  ahora: Date = new Date(),
): BackendSorteoSeleccionable | null {
  return obtenerSorteoMasProximoACerrar(
    sorteos.filter((sorteo) => sorteo.tipo_id === tipoId),
    ahora,
  );
}

export function tipoPosDesdeTipoId(tipoId: string): SorteoType | null {
  if (tipoId === 'NORMAL') return 'TICA';
  if (tipoId === 'REVENTADO') return 'REVENTADO';
  if (tipoId === 'MEGA') return 'MEGA';
  if (tipoId === 'MONAZOS') return 'MONAZOS';
  if (tipoId === 'FECHAS') return 'FECHAS';
  if (tipoId === 'PARLEY') return 'PARLEY';
  return null;
}
